/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "loader_colors_primary": "border-gray-900",
  "loader_size_default": "h-24 w-24",
  "loader_variant_default": "animate-spin rounded-full border-b-4",
  "colors_primary": "",
  "size_default": "",
  "variant_default": "my-16 flex items-center justify-center"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Spinner");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;